import axios from 'axios';
import authHeader from './auth-header';
import { API_ADMIN_URL, API_ADMIN_V6_URL } from './config';

const API_URL = API_ADMIN_URL + "/";
const API_URL_V3 = API_ADMIN_V6_URL + "/";

class UserService {

    getReport() {
        return axios.get(API_URL_V3 + "report", { headers: authHeader() });
    }

    searchUser(tool, keyword) {
        console.log(tool)
        return axios.get(API_URL_V3 + tool + "?search=" + keyword, { headers: authHeader() });
    }

    getAllUser(tool, indexItem, searchKeyword) {
        console.log(tool)
        console.log(indexItem)
        console.log(searchKeyword)
        if (searchKeyword) {
            return axios.get(API_URL + tool + "?search=" + searchKeyword, { headers: authHeader() });
        } else {
            return axios.get(API_URL + tool + "?indexItem=" + indexItem, { headers: authHeader() });
        }
    }

    getUserByUsername(tool, username) {
        return axios.get(API_URL + tool + "/" + username, { headers: authHeader() }).then(response => {
            return response.data;
        });
    }

    deleteUserByUserId(tool, id) {
        return axios.delete(API_URL_V3 + tool + "/" + id, { headers: authHeader() });
    }

    updateUserByUserId(tool, id, obj) {
        return axios.put(API_URL_V3 + tool + "/" + id, obj, { headers: authHeader() })
    }

    createUser(tool, obj) {
        return axios.post(API_URL_V3 + tool, obj, { headers: authHeader() })
    }


    insertChildDevice(tool, obj) {
        return axios.post(API_URL_V3 + tool + "/device", obj, { headers: authHeader() })
    }

    updateChildDevice(tool, obj, id) {
        return axios.put(API_URL_V3 + tool + "/device/" + id, obj, { headers: authHeader() })
    }

    resetChildDevice(tool, obj) {
        return axios.put(API_URL_V3 + tool + "/device/reset", obj, { headers: authHeader() })
    }

    deleteChildDevice(tool, id) {
        return axios.delete(API_URL_V3 + tool + "/device/" + id, { headers: authHeader() });
    }

    createUserMail(tool, obj) {
        return axios.post(API_URL_V3 + `now/${tool}`, obj, { headers: authHeader() })
    }

    findUser(tool, input) {
        return axios.get(`${API_URL}/admin/${tool}/${input}`, { headers: authHeader() });
    }

    createSuccessExtendOrder(tool, id, obj) {
        return axios.post(`${API_URL}/admin/${tool}/${id}/success-extend`, obj, { headers: authHeader() })
    }

    createWaitingExtendOrder(tool, id, obj) {
        return axios.post(`${API_URL}/admin/${tool}/${id}/waiting-extend`, obj, { headers: authHeader() })
    }

}

export default new UserService();
